import React, { useState, useEffect } from 'react'
import { Box, Flex, Select, Group, Button } from '@mantine/core'
import { useDebouncedCallback } from '@mantine/hooks'
import { getAllCountryList } from '../../../services/location'
import LoadingData from '../../ui/LoadingData'

const defaultParams = {
  'page[num]': 1,
  'page[limit]': 10,
  'filter[featured][is]': null,
  'filter[active][is]': null,
  'filter[principal_brand][is]': null,
  'filter[is_import][is]': null,
  'filter[is_partnered][is]': null,
  'filter[countries.id][is]': null
}

const defaultFeatured = [
  {
    label: 'Yes',
    value: '1'
  },
  {
    label: 'No',
    value: '0'
  },
]
const defaultIsImport = [
  {
    label: 'Yes',
    value: '1'
  },
  {
    label: 'No',
    value: '0'
  },
]
const defaultIsPartnered = [
  {
    label: 'Yes',
    value: '1'
  },
  {
    label: 'No',
    value: '0'
  },
]

const defaultPrincipal = [
  {
    label: 'Yes',
    value: '1'
  },
  {
    label: 'No',
    value: '0'
  },
]

const defaultActive = [
  {
    label: 'Active',
    value: '1'
  },
  {
    label: 'Inactive',
    value: '0'
  },
]

const FormFilterBrands = ({ paramsBrands, applyFilter, onClose }) => {
  const [parameter, setParameter] = useState(defaultParams)
  const [countryList, setCountryList] = useState([])
  const [loadingCountry, setLoadingCountry] = useState(true)

  const handleGetListCountry = useDebouncedCallback(async () => {
    setLoadingCountry(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'fields[country]': 'name',
    }
    try {
      const response = await getAllCountryList(parameter)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setCountryList(remapDataCountry)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCountry(false)
    }
  }, 300)

  useEffect(() => {
    if (paramsBrands !== null) {
      handleSetParams(paramsBrands)
    }
    // eslint-disable-next-line
  }, [paramsBrands])

  useEffect(() => {
    handleGetListCountry()
    // eslint-disable-next-line
  }, [paramsBrands])

  const handleSetParams = (val) => {
    const prevParams = {
      'filter[featured][is]': val['filter[featured][is]'],
      'filter[active][is]': val[`filter[active][is]`],
      'filter[principal_brand][is]': val['filter[principal_brand][is]'],
      'filter[is_import][is]': val['filter[is_import][is]'],
      'filter[is_partnered][is]': val['filter[is_partnered][is]'],
      'filter[countries.id][is]': val['filter[countries.id][is]']
    }
    setParameter(prevParams)
  }

  const handleChangeFilter = (name, val) => {
    setParameter((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleApplyFilter = (params) => {
    const valueParams = {
      ...params,
      'page[num]': 1,
      'page[limit]': 15,
    }
    applyFilter(valueParams)
    onClose()
  }

  const mappingFormFilter = () => {
    return (
      <Box>
        <Box mb='md'>
          <Select
            name='filter[featured][is]'
            value={parameter['filter[featured][is]']}
            label='Featured'
            data={defaultFeatured}
            onChange={(val) => handleChangeFilter('filter[featured][is]', val)}
            size='xs'
            clearable
          />
        </Box>
        <Box mb='md'>
          <Select
            name='filter[principal_brand][is]'
            value={parameter['filter[principal_brand][is]']}
            label='Principal Brand'
            onChange={(val) => handleChangeFilter('filter[principal_brand][is]', val)}
            data={defaultPrincipal}
            size='xs'
            clearable
          />
        </Box>
        <Box mb='md'>
          <Select
            name='filter[active][is]'
            value={parameter['filter[active][is]']}
            label='Active / Inactive'
            onChange={(val) => handleChangeFilter('filter[active][is]', val)}
            data={defaultActive}
            size='xs'
            clearable
          />
        </Box>

        <Box mb='md'>
          <Select
            name='filter[is_import][is]'
            value={parameter['filter[is_import][is]']}
            label='Imported Brand'
            onChange={(val) => handleChangeFilter('filter[is_import][is]', val)}
            data={defaultIsImport}
            size='xs'
            clearable
          />
        </Box>

        <Box mb='md'>
          <Select
            name='filter[is_partnered][is]'
            value={parameter['filter[is_partnered][is]']}
            label='Is Partnered'
            onChange={(val) => handleChangeFilter('filter[is_partnered][is]', val)}
            data={defaultIsPartnered}
            size='xs'
            clearable
          />
        </Box>

        <Box mb='md'>
          <Select
            name='filter[countries.id][is]'
            value={parameter['filter[countries.id][is]']}
            label='Country'
            onChange={(val) => handleChangeFilter('filter[countries.id][is]', val)}
            data={countryList}
            searchable
            size='xs'
            clearable
          />
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onClose}>Close</Button>
              <Button size='xs' variant="filled" onClick={() => handleApplyFilter(parameter)}>Apply Filter</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }
  return (
    <Box>
      {loadingCountry ? <LoadingData /> : mappingFormFilter()}
    </Box>
  )
}

export default FormFilterBrands